"use client";

import * as React from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SecureCollaboration() {
  return <section data-section-id="228870" id="pronto-para-posicionar-sua-empresa" className="dark bg-background text-foreground section px-4 sm:px-6 lg:px-8" style={{
    ['--foreground' as any]: 'hsl(0 0% 10%)',
    ['--card-foreground' as any]: 'hsl(0 0% 10%)',
    ['--color-logo' as any]: 'hsl(0 0% 10%)',
    ['--accent' as any]: 'hsl(270 70% 45%)',
    ['--section-vertical-padding' as any]: '160px'
  }}>
      <div className="max-w-6xl mx-auto border-8 border-primary relative overflow-hidden p-8 sm:p-16 md:p-24 flex flex-col items-center justify-center text-center bg-card shadow-4xl">
        {}
        <div className="absolute inset-0 z-0 opacity-5 pointer-events-none" style={{
        backgroundImage: `
              linear-gradient(to right, var(--color-primary) 1px, transparent 1px),
              linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)
            `,
        backgroundSize: '48px 48px'
      }} aria-hidden="true" />

        {}
        <div className="relative z-10 flex flex-col items-center gap-12 w-full">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tighter uppercase leading-tight text-muted-foreground" style={{
          color: 'hsl(0 0% 98%)'
        }}>
            Pronto para
            <br />
            posicionar sua
            <br />
            empresa?
          </h2>

          <Button asChild size="lg" className="text-lg sm:text-xl md:text-2xl px-8 sm:px-12 py-8 md:py-10 h-auto rounded-full font-default font-bold uppercase tracking-wider shadow-xl hover:scale-105 transition-transform duration-300 w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="https://wa.me/5511969100007?text=Olá,%20vim%20pelo%20site%20da%20ITC%20%20e%20quero%20entender%20como%20voc%C3%AAs%20podem%20me%20ajudar" newTab>
              Falar com especialista
              <ExternalLink className="ml-3 size-6 sm:size-8" />
            </Link>
          </Button>

          <div className="border-t-2 border-border pt-8 w-full max-w-2xl">
            <p className="text-muted-foreground text-sm sm:text-base md:text-lg font-mono uppercase tracking-widest">
              Estúdio em Pinheiros • Produção Audiovisual • SEO & Conversão
            </p>
          </div>
        </div>
      </div>
    </section>;
}